import React from 'react';
import TaskItem from './TaskItem'; // Importamos el componente individual

// Recibe la lista de tareas y las funciones por 'props'
const TaskList = ({ tasks, onToggleComplete, onDeleteTask, onUpdateTaskDate }) => { // Recibe la nueva 'prop'
    return (
        <ul className="task-list">
            {tasks.map((task) => (
                <TaskItem
                    key={task.id}
                    task={task} // Pasamos el objeto tarea
                    onToggleComplete={onToggleComplete} // Pasamos la función
                    onDeleteTask={onDeleteTask} // Pasamos la función
                    onUpdateTaskDate={onUpdateTaskDate} // Pasa la nueva 'prop' en TaskItem
                />
            ))}
        </ul>
    );
};

export default TaskList;